import AdminNavBarItem from './AdminNavBarItem'
export default AdminNavBarItem



// WEBPACK FOOTER //
// ./src/components/AdminNavBarItem/index.js